import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MasterModule } from './master.module';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptorService } from './interceptor/http-error-interceptor.service';
import { MatIconRegistry } from '@angular/material/icon';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { HttpClientModule } from '@angular/common/http';
import { SpinnerInterceptorService } from './interceptor/spinner-interceptor.service';
import { CommonModule } from '@angular/common';
import { AppmodalComponent } from './shared/modal/appmodal/appmodal.component';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { ActiveLookupCacheInterceptor } from './interceptor/active-lookup-cache.interceptor';
import { AuthService } from './api-services/AdminHRService/Login/auth.service';
import { firstValueFrom } from 'rxjs';
import { ChatWidgetComponent } from './shared/AIBoat/chat-widget/chat-widget.component';
import { MessageBubbleComponent } from './area/module/AI/message-bubble/message-bubble.component';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';

registerLocaleData(localeIn);

@NgModule({
  declarations: [
    AppComponent,
    ChatWidgetComponent,     // ← add
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    MasterModule,
    RouterModule,
    MatProgressSpinnerModule,
    AppmodalComponent,
    MessageBubbleComponent,  // ← standalone → imports

  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ActiveLookupCacheInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true
    },
     { provide: LOCALE_ID, useValue: 'en-IN' }
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
  }
}

export function initAuth(authService: AuthService) {
  return () => firstValueFrom(authService.restoreSession());
}
